/*
 * Scroll reveal
 * - IntersectionObserver でホームページのコンテンツセクションをフェードイン＋上スライド。
 * - ブランドショーケースのタイルは 0.1 秒ずつ遅延（stagger）。
 * - 初期表示時にすでにビューポート内にある要素は、.scroll-reveal と .is-visible を
 *   同一タスク内で付与することでちらつき（FOUC）を防ぐ。
 * - prefers-reduced-motion 時は監視せず即時表示（CSS 側でもアニメーションを無効化）。
 */
(function () {
  'use strict';

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    // ホームページ（index）のみ対象
    if (main.getAttribute('data-template') !== 'index') return;

    var prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var targets = [];
    var sections = main.querySelectorAll(':scope > .shopify-section');

    sections.forEach(function (section, index) {
      // 先頭セクション（ヒーロー）はアニメーションしない
      if (index === 0) return;

      var showcase = section.querySelector('.brand-showcase');
      if (showcase) {
        // ブランドショーケース：各タイルを 0.1 秒ずつ遅延
        var tiles = showcase.querySelectorAll('.brand-tile');
        tiles.forEach(function (tile, tileIndex) {
          tile.style.setProperty('--reveal-delay', tileIndex * 0.1 + 's');
          targets.push(tile);
        });
        return;
      }

      // その他のコンテンツセクション（コンセプト／読みもの／NEWS など全般）
      var inner = section.querySelector('.section') || section;
      targets.push(inner);
    });

    if (!targets.length) return;

    // reduced-motion 時はクラスを付けず、そのまま表示
    if (prefersReduced) return;

    var supportsObserver = 'IntersectionObserver' in window;

    var observer = supportsObserver
      ? new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                obs.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
        )
      : null;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    targets.forEach(function (el) {
      // 非表示クラスとビューポート判定を同一タスクで処理 → ちらつき防止
      el.classList.add('scroll-reveal');

      var rect = el.getBoundingClientRect();
      var inView = rect.top < viewportHeight && rect.bottom > 0;

      if (!observer || inView) {
        // すでに見えている、または IO 非対応：即時表示
        el.classList.add('is-visible');
        return;
      }

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
